import React from 'react'
import Skeleton from 'react-loading-skeleton'
import {formatMoney} from "accounting"
import { Card, TreeSelect, Select, Icon } from 'antd'
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts'

export default ({ date_selection_ranges=[], selected_date_range,  selected_service, products_tree,
                    selected_service_cmp, budget, has_write_perm, chart_width, loading,
                    chart_data, selected_service_name, selected_service_cmp_name,
                    on_toggle_set_alert, on_service_change, on_service_compare_add,
                    on_service_compare_toggle, on_selected_date_range_change
                }) => {

    const props = {
        type: 'monotone',
        strokeWidth: 3,
        activeDot: {r: 6},
        isAnimationActive: true
    }

    return (
        <Card
            title={
                <div>
                    <span>Actual vs. Budgeted Spending</span>

                    <div>
                        {/*<Select
                            value                    = {selected_cloud}
                            onChange                 = {on_cloud_change}
                            dropdownMatchSelectWidth = {true}
                            placeholder              = {'Select cloud account'}
                            style                    = {{width: 170}}
                            size                     = {'large'}
                            className                = 'range_select'>
                            {clouds.map(({id, project_name}) => <Select.Option key={id} value={id}>{project_name}</Select.Option>)}
                        </Select>*/}

                        <Select value       = {selected_date_range}
                                style       = {{ width: 170 }}
                                className   = 'range_select'
                                size        = {'large'}
                                onChange    = {on_selected_date_range_change} >
                            {date_selection_ranges.map((r, i)=> <Select.Option key={i} value={r.value}>{r.label}</Select.Option>)}
                        </Select>

                        <TreeSelect placeholder = 'Select service'
                                    value       = {selected_service}
                                    className   = 'services'
                                    size        = {'large'}
                                    treeData    = {products_tree}
                                    style       = {{width:170}}
                                    onSelect    = {val => on_service_change('selected_service', val)}
                                    treeDefaultExpandedKeys = {['total']}/>

                        {
                            selected_service_cmp && <TreeSelect placeholder = 'Add Comparison'
                                        value       = {selected_service_cmp}
                                        className   = 'add-comp-services'
                                        size        = {'large'}
                                        treeData    = {products_tree}
                                        style       = {{width:170}}
                                        onSelect    = {val => on_service_change('selected_service_cmp', val)}
                                        treeDefaultExpandedKeys = {['total']}/>
                        }

                        <Icon key='3' type={selected_service_cmp?'close-square':'plus-square'} theme="outlined" className={'service-cmp-' + selected_service_cmp ? 'close':'plus'} onClick={on_service_compare_toggle} />
                    </div>
                </div>
            }
              className='finance-trend' >
            {
                !chart_data.length && loading ? <Skeleton count={10}/>:
                    <LineChart
                        width  = {chart_width}
                        height = {300}
                        margin = {{left:20, right:10}}
                        data   = {chart_data}>

                        <YAxis tickFormatter={(value=0)=> value.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}/>

                        <XAxis dataKey='month'/>

                        <CartesianGrid vertical={false}/>
                        <Tooltip/>
                        <Legend verticalAlign='top' align='right' iconType='circle' height={50}
                                iconSize={10} />
                        <Line dataKey='actual' name={`Actual ${selected_service}`}
                              stroke='#9693db' {...props} />
                        <Line dataKey='budget' name={`Budgeted ${selected_service}`}
                              stroke='#9bd3b0' {...props} />
                        {
                            selected_service_cmp && [
                                <Line key='1' dataKey='actual_cmp' name={'Actual ' + selected_service_cmp}
                                      stroke='#b2e8fe' {...props} />,
                                <Line key='2' dataKey='budget_cmp' name={'Budgeted ' + selected_service_cmp}
                                      stroke='#fd7670' {...props} />
                            ]
                        }
                        {/*<Brush/>*/}
                    </LineChart>
            }
        </Card>
    )
}
